import React, { Component, KeyboardEvent } from 'react';
import AutoresizableInput from './autoresizableInput';

export type InputEvent = {
  currentTarget: {
    value: string;
  };
};

interface IProps {
  name: string;
  value: Array<string>;
  onChange: (name: string, keys: Array<string>) => void;
  disabled: boolean;
}

interface IState {
  autoFocus: boolean;
}

class FormSet extends Component<IProps, IState> {
  state: IState = { autoFocus: false };

  add = (e: InputEvent) => {
    const { name, value, onChange } = this.props;
    const newValue = e.currentTarget.value;

    const keys = newValue !== '' ? [...value, newValue] : value;

    if (!this.validate(keys, newValue)) {
      return;
    }

    onChange(name, keys);
    this.setState({ autoFocus: true });
  };

  delete = (i: number) => {
    const { name, value, onChange } = this.props;
    const keys = [...value.slice(0, i), ...value.slice(i + 1)];

    onChange(name, keys);
  };

  update = (e: InputEvent, i: number) => {
    const { name, value, onChange } = this.props;
    const newValue = e.currentTarget.value;

    const keys =
      newValue === ''
        ? [...value.slice(0, i), ...value.slice(i + 1)]
        : [...value.slice(0, i), newValue, ...value.slice(i + 1)];

    onChange(name, keys);
  };

  validate = (keys: Array<string>, value: string) => keys.filter((item) => item === value).length <= 1;

  keyHandler = (e: KeyboardEvent<HTMLInputElement>, i?: number) => {
    if (e.keyCode === 13) {
      if (!i) {
        this.add(e);
      }
    }
  };

  render() {
    const { value } = this.props;
    const { autoFocus } = this.state;

    return (
      <React.Fragment>
        {value.map((m, i) => (
          <div className="cc-setInput__wrapper" key={m}>
            <AutoresizableInput
              type="text"
              defaultValue={m}
              onBlur={(e: InputEvent) => {
                this.update(e, i);
              }}
              onKeyDown={(e) => {
                this.keyHandler(e, i);
              }}
              onClear={() => {
                this.delete(i);
              }}
            />
          </div>
        ))}
        <AutoresizableInput
          key={value.length}
          type="text"
          defaultValue=""
          autoFocus={!!autoFocus}
          onBlur={this.add}
          onKeyDown={this.keyHandler}
        />
      </React.Fragment>
    );
  }
}

export default FormSet;
